export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12 overflow-hidden relative">
          <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/95 to-background-950/70 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-1/2 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20mobile%20phone%20screen%20displaying%20entertainment%20video%20app%20interface%2C%20warm%20amber%20accents%20on%20dark%20theme%2C%20modern%20video%20platform%20UI%2C%20no%20recognizable%20people%2C%20no%20real%20brands&width=800&height=800&seq=app-bg-51hl&orientation=squarish"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
              随时随地 · 畅快吃瓜
            </h2>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-md mb-6">
              51黑料移动端适配完美，无论手机还是平板，都能享受高清流畅的51黑料在线视频观看体验。关注微信公众号「51黑料吃瓜」，第一时间获取最新推送。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="bg-accent-500 hover:bg-accent-600 text-background-950 px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-smartphone-line text-lg"></i>
                移动端入口
              </a>
              <a
                href="#contact"
                className="bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/20 px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-wechat-line text-lg"></i>
                关注公众号
              </a>
            </div>
          </div>

          <div className="relative z-10 w-48 md:w-56 lg:w-64 flex-shrink-0">
            <div className="rounded-2xl overflow-hidden border-2 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20dark%20theme%20mobile%20app%20screenshot%20mockup%20showing%20entertainment%20video%20feed%20with%20thumbnails%2C%20warm%20amber%20accent%20UI%20elements%2C%20sleek%20video%20platform%20design%2C%20no%20people%2C%20no%20real%20brands%2C%20no%20text&width=600&height=800&seq=app-mock-51hl&orientation=portrait"
                alt="51黑料移动端界面"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}